<div class="card">
  <div class="card-header">
    <i class="fa fa-regular fa-rectangle-list"></i>Constancia de Saldos
    <div class="card-header-actions btn-group" dropdown placement="bottom left">
      <!-- <button class="btn btn-sm btn-outline-success" type="button"><i class="fa fa-regular fa-floppy-disk"></i>&nbsp;Guardar Orden</button> -->
      <button class="btn btn-sm btn-outline-success" type="button" appPrivilege="print-balance-record-action"
        (appPrivilegeClick)="handlePrintClick()">
        <i class="fa fa-regular fa-file"></i>&nbsp;Imprimir Constancia
      </button>
    </div>
  </div>
  <div class="card-body">
    <accordion [isAnimated]="true">
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-users"></i> Información General
        </span>
        <div class="form-group row">
          <label class="col-md-3 col-form-label"><b>Cliente</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="customerInformation"
              disabled />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="text-input"><b>Documento Fiscal</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="fiscalNumber"
              disabled />
          </div>
        </div>
      </accordion-group>
      <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class="fa fa-regular fa-file-lines"></i> Datos para Impresion
        </span>

        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="salesOrg"><b>Seleccione Organizaciones</b></label>
          <div class="col-md-9">
            <ng-select name="salesOrg" [items]="salesOrgs.content" bindLabel="name" [multiple]="true"
              [(ngModel)]="salesOrg" [closeOnSelect]="false" [selectOnTab]="true" (change)="selectSalesOrg($event)"
              required>
            </ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 col-form-label" for="text-input"><b>Dirigido A</b></label>
          <div class="col-md-9">
            <input type="text" id="text-input" name="text-input" class="form-control" [(ngModel)]="toWhom" />
          </div>
        </div>
      </accordion-group>
    </accordion>
  </div>
</div>
<!-- <div class="form-actions" >
  <button class="btn btn-outline-primary" type="button" (click)="handlePrintClick()" appPrivilege="print-balance-record-action">Imprimir</button>
</div> -->